import { render, staticRenderFns } from "./BoardRead.vue?vue&type=template&id=46adb71b"
import script from "./BoardRead.ts?vue&type=script&lang=ts&external"
export * from "./BoardRead.ts?vue&type=script&lang=ts&external"
import style0 from "./BoardRead.vue?vue&type=style&index=0&id=46adb71b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports